import { styled } from '@mui/material';
import { LoadingButton } from 'components';

export const StyledDownloadSongButton = styled(LoadingButton)(({ theme }) => ({
  height: theme.spacing(5),
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
  fontSize: 12,
  fontWeight: 500,
  borderRadius: theme.spacing(2.5),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.grey[900],
  textTransform: 'none',
  [theme.breakpoints.down('sm')]: {
    background: 'none',
    color: theme.palette.primary.main,
    minWidth: 'initial',
    padding: 0,
    '.MuiButton-startIcon': {
      margin: 0,
    },
  },
}));
